module.exports = __webpack_public_path__ + "static/media/holiday_here_logo.56a13cdd.png";